import { observer } from 'mobx-react-lite'

import { useStore } from 'store/useStore'
import { TextPromo } from 'components/ui'

import { ChatModal } from './components/ChatModal/ChatModal'

import Logo from 'assets/img/searchEngine/searchEngineIcon.svg?react'
import s from './SearchEngine.module.scss'

export const SearchEngine = observer(() => {
  const { searchEngineUiStore: uiStore } = useStore()
  const handleOpenModal = (value: boolean) => {
    uiStore.toggleIsOpen(value)
  }

  return (
    <>
      <ChatModal />
      <button onClick={() => handleOpenModal(true)} className={s.searchEngineActivationBtn}>
        <Logo className={s.searchEngineIcon} />
        <TextPromo className={s.searchEngineButtonText} fontFamily="ASLHaussVF" size="s20" weight="w550">
          Задать вопрос
        </TextPromo>
      </button>
    </>
  )
})
